import { render, staticRenderFns } from "./GalleryImg.vue?vue&type=template&id=be09392a"
import script from "./GalleryImg.vue?vue&type=script&lang=js"
export * from "./GalleryImg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports